import React from "react";
import { withRouter } from "react-router";
import Header from "../../../_legacy/Containers/Guest/Header.js";
import Footer from "../../../_legacy/Containers/Guest/Footer.js";

const KlarnaCompletedPayment = () => {
  return (
    <div className="guest">
      <Header />
      <div className="wrapper">
        <div className="card-block">
          <div className="login-main m-t-60">
            <img
              alt=""
              className="height38px m-auto m-b-40"
              src="/images/klarna-black-logo.png"
            />
            <h1>Payment completed!</h1>
            <h4 className="m-b-40">The transaction was successful.</h4>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(KlarnaCompletedPayment);
